import dayjs from 'dayjs'

import { DEFAULT_TIMEZONE } from '@/components/entities/requests/model/constants'

import { DateRange } from '../ui/Calendar.types'
import { getDisplayRangeEnd } from './getDisplayRangeEnd'

export const getDateLabel = (range: DateRange, showDay = true) => {
  const currentYear = new Date().getFullYear()
  const fromYear = range?.from?.getFullYear()
  const toYear = range?.to?.getFullYear()
  const formatWithoutYear = showDay ? 'D MMMM' : 'MMMM'
  const formatWithYear = showDay ? 'D MMMM YYYY' : 'MMMM YYYY'
  const formatForPastPeriod = showDay ? 'DD.MM.YYYY' : 'MMMM YYYY'

  if (range.from && !range.to) {
    return fromYear === currentYear
      ? dayjs(range.from).format(formatWithoutYear)
      : dayjs(range.from).format(formatWithYear)
  }

  if (range.from && range.to && dayjs(range.from).isSame(range.to, 'day')) {
    return fromYear === currentYear
      ? dayjs(range.from).format(formatWithoutYear)
      : dayjs(range.from).format(formatWithYear)
  }

  if (!fromYear || !toYear) {
    return ''
  }

  if (fromYear === currentYear && toYear === currentYear) {
    return `${dayjs(range.from).format(formatWithoutYear)} — ${dayjs(
      range.to
    ).format(formatWithoutYear)}`
  }

  if (fromYear <= toYear) {
    return `${dayjs(range.from).format(formatForPastPeriod)} — ${dayjs(
      range.to
    ).format(formatForPastPeriod)}`
  }

  return ''
}

export const getHoursDateLabel = (range: DateRange) => {
  if (!range?.from) {
    return ''
  }

  const from = dayjs(range.from).tz(DEFAULT_TIMEZONE)
  const fromTime = from.format('HH:mm')
  const fromDay = from.format('D MMMM')

  if (!range.to) {
    return `${fromTime}, ${fromDay}`
  }

  const to = dayjs(getDisplayRangeEnd(range.to)).tz(DEFAULT_TIMEZONE)
  const toTime = to.format('HH:mm')

  if (from.isSame(to, 'day')) {
    return `${fromTime}-${toTime}, ${fromDay}`
  }

  return `${fromTime}, ${fromDay} — ${toTime}, ${to.format('D MMMM')}`
}
